import type { ApiOrgId } from '#/api/types/ApiTypedId';
import type { OrgDashboardApiCurrentGradFair } from '#/modules/orgDashboard/api/gradFairs/api/types/OrgDashboardApiCurrentGradFair';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = OrgDashboardApiCurrentGradFair;

function mapResponse(response: ApiResponse) {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId) => `/data/orgdashboard/${orgId}/grad-fairs`,
  mapResponse,
});

// Exports

export const orgDashboardApiIsomorphicFetchCurrentGradFair =
  endpoint.createIsomorphicFetchFn();

export const orgDashboardApiClientFetchCurrentGradFair =
  endpoint.createClientFetchFn();
